import { css } from 'styled-components';

const commonResets = css `
    font-family: 'Inter', sans-serif;
    padding: 0;
    margin: 0;
    outline: none;
    border: none;
    box-sizing: border-box;
`;

export { commonResets };
